import {
  Box,
  styled,
  TextField as TextFieldStyle,
  Button,
  css,
} from '@mui/material';

interface ButtonProps {
  active: boolean;
}

export const Container = styled(Box)`
  padding: 30px 30px 42px 30px;
  background: ${({ theme }) => theme.palette.grey[50]};
  width: 100%;
  height: 100%;
  overflow-y: overlay;
`;

export const Header = styled(Box)`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
  align-items: center;

  .css-1d3z3hw-MuiOutlinedInput-notchedOutline {
    border-style: 'hidden';
  }
`;

export const TabSelection = styled(Box)`
  display: flex;
  flex-direction: row;
  background: #ffffff;
  border-radius: 4px;
  Button {
    width: 160px;
    height: 48px;
    padding: 17px 43px;
    border-radius: 0;
  }
`;

export const TabButton = styled(Button)`
  color: rgba(0, 0, 0, 0.54);
  ${(props: ButtonProps) =>
    props.active &&
    css`
      font-weight: 800;
      border-bottom: 2px solid #206da7;
      color: #206da7;
    `}
`;

export const TextField = styled(TextFieldStyle)`
  .css-1d3z3hw-MuiOutlinedInput-notchedOutline {
    border-style: 'hidden';
  }
`;

export const Div = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
